import { render, staticRenderFns } from "./promotion-discount-codes-show.vue?vue&type=template&id=4ca99efd"
import script from "./promotion-discount-codes-show.vue?vue&type=script&lang=js"
export * from "./promotion-discount-codes-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports